const configProviderInjectionKey = Symbol("ArcoConfigProvider");
export { configProviderInjectionKey };
